module.exports = __webpack_public_path__ + "img/arrow-left.e2360207.svg";